import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[800]
	},
	link: {
		width: "fit-content"
	}
}))

export default useStyles
